import { useState, createContext, useContext, useMemo } from "react";
import { getUserProfile } from "services/UserManagementServices";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem("userExists") || null);

  const performLogin = async () => {
    setUser(true);
  };

  const performLogout = () => {
    setUser(null);
  };

  const contextValue = useMemo(
    () => ({
      user,
      performLogin,
      performLogout,
    }),
    [user]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
